import {Button, ButtonGroup} from "retro-react";
import { fetchMedia } from "../../../api/media";
import { useApi } from "../../../hooks/useApi";


export const Buttons =({
    pFarLeftButtonTitle, pFarLeftMediaID,
    pLeftButtonTitle, pMediaID,
    pMiddleButtonTitle, pMiddleButtonUrl,
    pRightButtonTitle, pRightButtonUrl
    }) =>{ 
        //artist cv button
        const {output: farLeftMediaObject, loading: farLeftAboutLoading, error: farLeftAboutError} = useApi(fetchMedia, pFarLeftMediaID); 
        const pFarLeftMediaUrl = farLeftMediaObject?.source_url;
        //cv button
        const {output: mediaObject, loading: aboutLoading, error: aboutError} = useApi(fetchMedia, pMediaID); 
        const pMediaUrl = mediaObject?.source_url;
    return(
        <ButtonGroup className="about-button-group" size="large">
            {/* <Button  onClick={ () => window.open(`${pFarLeftMediaUrl}`, "_blank")}>
                {pFarLeftButtonTitle}
            </Button>   */}
            <Button  onClick={ () => window.open(`${pMediaUrl}`, "_blank")}>
                {pLeftButtonTitle}
            </Button>
            <Button onClick={ () => window.open(`${pMiddleButtonUrl}`, "_blank")}>
                {pMiddleButtonTitle}
            </Button>
            <Button onClick={ () => window.open(`${pRightButtonUrl}`, "_blank")} >
                {pRightButtonTitle}
            </Button>
        </ButtonGroup>   
    );
}

export const MobileButtons = ({
    pFarLeftButtonTitle, pFarLeftMediaID,
    pLeftButtonTitle, pMediaID,
    pMiddleButtonTitle, pMiddleButtonUrl,
    pRightButtonTitle, pRightButtonUrl
    }) =>{ 
        //artist cv button
        const {output: farLeftMediaObject, loading: farLeftAboutLoading, error: farLeftAboutError} = useApi(fetchMedia, pFarLeftMediaID); 
        const pFarLeftMediaUrl = farLeftMediaObject?.source_url;
        //cv button
        const {output: mediaObject, loading: aboutLoading, error: aboutError} = useApi(fetchMedia, pMediaID); 
        const pMediaUrl = mediaObject?.source_url;

    return(
        <ButtonGroup className="about-button-group" size="small">
            {/* <Button  onClick={ () => window.open(`${pFarLeftMediaUrl}`, "_blank")}>
                {pFarLeftButtonTitle}
            </Button> */}
            <Button  onClick={ () => window.open(`${pMediaUrl}`, "_blank")}>
                {pLeftButtonTitle}
            </Button>
            <Button onClick={ () => window.open(`${pMiddleButtonUrl}`, "_blank")}>
                {pMiddleButtonTitle}
            </Button>
            <Button onClick={ () => window.open(`${pRightButtonUrl}`, "_blank")} >
                {pRightButtonTitle}
            </Button>
        </ButtonGroup>   
    );
}